"use client";

import {
  AutumnClient
} from "./chunk-XDAZD5HF.mjs";

// src/libraries/react/AutumnContext.tsx
import { createContext, useContext } from "react";
var AutumnContext = createContext({
  initialized: false,
  client: new AutumnClient({
    backendUrl: process.env.NEXT_PUBLIC_AUTUMN_BACKEND_URL
  }),
  paywallDialog: {
    props: null,
    setProps: () => {
    },
    open: false,
    setOpen: () => {
    },
    setComponent: () => {
    }
  },
  prodChangeDialog: {
    props: null,
    setProps: () => {
    },
    open: false,
    setOpen: () => {
    },
    setComponent: () => {
    }
  }
});
var useAutumnContext = ({
  AutumnContext: AutumnContext2,
  name
}) => {
  const context = useContext(AutumnContext2);
  if (!context.initialized) {
    throw new Error(`${name} must be used within <AutumnProvider />`);
  }
  return context;
};

export {
  AutumnContext,
  useAutumnContext
};
